import { render } from "./GrupoMaterialList.vue?vue&type=template&id=2b7f2536&scoped=true"
import script from "./GrupoMaterialList.vue?vue&type=script&lang=js"
export * from "./GrupoMaterialList.vue?vue&type=script&lang=js"

import "./GrupoMaterialList.vue?vue&type=style&index=0&id=2b7f2536&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7f2536"]])

export default __exports__